import { takeLatest, put, select, all, call } from 'redux-saga/effects';
import { get } from '@api/sharing';
import { getDefaultStore } from 'jotai';
import { autoRequest } from '@api/createRequestStore';
import { DASHBOARD_TYPE } from '@utils/constants';
import { message } from 'antd';
import { TRIGGER_ADD_TAB } from '@store/dashboards/tabs/types';
import { SAVE_DASHBOARD_PROMPT_VISIBILITY } from '@store/dashboards/ui/types';
import { NEW_SHARING_DASHBOARD_NAME } from '@store/dashboards/tabs/utils/constants';
import genApplyForAtomPersistence from '@store/common/initStore';
import { nocRouteKey } from '@utils/persistenceUtil';
import { addNewSharedTab } from '../../sharedTabs/action';
import * as actions from './actions';
import * as types from './types';
import selector, { sharingResponseSelector } from './selectors';
import { filterAndApplyState } from '../base/actions';

function* afterRequest() {
  const { state } = yield select(sharingResponseSelector);

  if (!state) {
    return;
  }
  const { payload } = yield select(selector);
  try {
    const { common, nocStore, atomState } = state;
    const { selectedCustomerId } = common;

    if (atomState) {
      const applyAtomPersistence = genApplyForAtomPersistence({
        configuration: { atomState },
        pageKey: nocRouteKey,
      });
      applyAtomPersistence(getDefaultStore());
    }

    yield all([
      put(filterAndApplyState(nocStore)),
      put(
        addNewSharedTab(
          {
            id: payload,
            state,
            type: DASHBOARD_TYPE.NOC,
            name: 'Real-Time',
          },
          selectedCustomerId,
        ),
      ),
      put({
        type: TRIGGER_ADD_TAB,
        payload: {
          config: { nocStore },
          dashboardTypeId: DASHBOARD_TYPE.NOC,
          unsaved: true,
          id: payload,
          name: '',
          isSharing: true,
        },
      }),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching({ id }) {
  yield actions.fetching();
  try {
    yield autoRequest(get, types.SCOPE, id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* addNocSharingTab() {
  const { state, id } = yield select(sharingResponseSelector);

  if (!state) {
    return;
  }

  try {
    const { nocStore } = state;
    const name = `Real-Time Sharing ${id}`;

    // after fetching sharing data, add a new tab data for user to save dashboard
    const shareId = `${NEW_SHARING_DASHBOARD_NAME}${id}`;

    yield all([
      put({
        type: TRIGGER_ADD_TAB,
        payload: {
          config: { nocStore },
          dashboardTypeId: DASHBOARD_TYPE.NOC,
          unsaved: true,
          id: shareId,
          name,
          isSharing: true,
        },
      }),
      put({
        type: SAVE_DASHBOARD_PROMPT_VISIBILITY,
        flag: false,
        id: shareId,
      }),
    ]);
  } catch (err) {
    console.error(err);
    throw err;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_SHARING], fetching);
}

function* watchAddNocSharingTab() {
  yield takeLatest([types.ADD_NOC_SHARING_TAB], addNocSharingTab);
}

export default [watchInitRequest, watchFetching, watchAddNocSharingTab];
